import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var COOKIE_NAME = 'uikit-color-scheme';
export var THEME_DATA_ATTRIBUTE = 'data-theme';
export var THEME_CHANGE_EVENT = 'themechange';
var PATH = '/';
var DOMAIN = '.rio.cloud';
var EXPIRATION_DATE = 'Thu, 18 Dec 2030 12:00:00 UTC';
export var THEME_DEFAULT = 'default';
export var THEME_SYSTEM = 'system';
export var THEME_LIGHT = 'light';
export var THEME_DARK = 'dark';
export var getColorScheme = function getColorScheme() {
  return readColorSchemeFromCookie();
};
export var setColorScheme = function setColorScheme(scheme) {
  return writeColorSchemeToCookie(scheme);
};
export var listenForSchemeChange = function listenForSchemeChange() {
  return listenForCookieChange();
};
var readColorSchemeFromCookie = function readColorSchemeFromCookie() {
  var decodedCookie = decodeURIComponent(document.cookie);
  console.debug(decodedCookie);
  var _decodedCookie$split$ = decodedCookie.split(';').filter(function (entry) {
      return entry.includes(COOKIE_NAME);
    }),
    _decodedCookie$split$2 = _slicedToArray(_decodedCookie$split$, 1),
    uikitCname = _decodedCookie$split$2[0];
  if (!uikitCname) {
    return;
  }
  var _uikitCname$split = uikitCname.split('='),
    _uikitCname$split2 = _slicedToArray(_uikitCname$split, 2),
    colorScheme = _uikitCname$split2[1];
  console.debug("readColorSchemeFromCookie: ".concat(colorScheme));
  if (!colorScheme) {
    return;
  }
  var html = document.documentElement;
  if (colorScheme === THEME_DEFAULT || colorScheme === THEME_SYSTEM) {
    html.removeAttribute(THEME_DATA_ATTRIBUTE);
    return colorScheme;
  }
  if (colorScheme === THEME_LIGHT || colorScheme === THEME_DARK) {
    html.setAttribute(THEME_DATA_ATTRIBUTE, colorScheme);
    return colorScheme;
  }
};

// This should be done by a RIO service like User Profile SPA using a theme switcher component from the uikit
// where this function is referenced
var writeColorSchemeToCookie = function writeColorSchemeToCookie(scheme) {
  var _window, _window2;
  var isDevEnv = ((_window = window) === null || _window === void 0 ? void 0 : _window.location.host.startsWith('localhost')) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.location.host.startsWith('127.0.0.1'));
  var newCookieValues = encodeURIComponent(scheme);
  var cookie = "".concat(COOKIE_NAME, "=").concat(newCookieValues, ";domain=").concat(isDevEnv ? 'localhost' : DOMAIN, ";expires=").concat(EXPIRATION_DATE, ";path=").concat(PATH);
  console.log("writeColorSchemeToCookie: ".concat(cookie));
  document.cookie = cookie;
};
var listenForCookieChange = function listenForCookieChange() {
  var _window3;
  var eventHandler = function eventHandler(event) {
    if (event.data === THEME_CHANGE_EVENT) {
      var _document;
      readColorSchemeFromCookie();

      // Re-send the event to all iframes that might not be notified yet
      _toConsumableArray((_document = document) === null || _document === void 0 ? void 0 : _document.getElementsByTagName('iframe')).map(function (frame) {
        var _frame$contentWindow;
        return (_frame$contentWindow = frame.contentWindow) === null || _frame$contentWindow === void 0 ? void 0 : _frame$contentWindow.postMessage(THEME_CHANGE_EVENT, '*');
      });
    }
  };
  (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener('message', eventHandler, false);
};